var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClipLoader',{attrs:{"color":_vm.color || '#0070ff',"size":_vm.size || '30px'}})
}
var staticRenderFns = []

export { render, staticRenderFns }